import Vue from 'vue';

Vue.filter('subscriptionStatus', (value: number) => {
  if (!value) {
    return '<n/a>';
  }
  switch (value) {
    case 50:
      return 'Active';
    case 90:
      return 'Stopped';
  }

  return '';
});
